import { colors } from 'assets/styled/tokens';
import styled from 'styled-components';

export const StyledSubCategoryItem = styled.li`
  display: block;
  background-color: ${colors.pampas};
  position: relative;
`;
